import { DoqType, ResponsiveDoqWithSpeechBubble } from '@ardoq/doq';
import { FlexBox, Stack } from '@ardoq/layout';
import { EmptyStatesDoqContainer } from '@ardoq/graph';
import { t, type I18nLocale } from '@ardoq/i18n';
import { i18nLocale$ } from 'streams/i18nLocale$';
import { connect } from '@ardoq/rxbeach';
import { map } from 'rxjs';

type NoReferencesDoqProps = { doqType: DoqType; i18nLocale: I18nLocale };

const NoReferencesDoqBase = ({ doqType, i18nLocale }: NoReferencesDoqProps) => {
  return (
    <EmptyStatesDoqContainer>
      <ResponsiveDoqWithSpeechBubble
        doqType={doqType}
        title={t(
          i18nLocale,
          'tabview:graphViews.emptyState.noReferences.title',
          'No reference to show'
        )}
        message={
          <Stack gap="xlarge">
            <FlexBox gap="medium">
              {t(
                i18nLocale,
                'tabview:graphViews.emptyState.noReferences.message1',
                'This context does not have any references.'
              )}
            </FlexBox>
            <FlexBox gap="medium">
              {t(
                i18nLocale,
                'tabview:graphViews.emptyState.noReferences.message2',
                'To use this view, select a context or workspace with at least one component referencing another.'
              )}
            </FlexBox>
          </Stack>
        }
      />
    </EmptyStatesDoqContainer>
  );
};
export const NoReferencesDoq = connect(
  NoReferencesDoqBase,
  i18nLocale$.pipe(map(i18nLocale => ({ i18nLocale })))
);
